export default
  "Candidatez au programme partenaires SEF : artisan RGE (mandat CEE), délégataire CEE, obligé énergie ou apporteur d'affaires. Un référent partenaires vous recontacte sous 24 h ouvrées.";
